import { http } from "./client";

// In-app notifications for the signed-in user (both views).
const data = (r) => r.data;
const clean = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && v !== "" && v !== false,
    ),
  );

export const notificationsApi = {
  // ?page&limit (≤100)&unreadOnly&group (Approvals|Results|HR alerts)&search&from&to (Manila dates)
  // → { data: [{ id, type, title, message, link, readAt, createdAt, group }], total, unread, page, limit }
  list: (params = {}) =>
    http.get("/notifications", { params: clean(params) }).then(data),
  // → { unread }
  unreadCount: () => http.get("/notifications/unread-count").then(data),
  // → { unread }
  markRead: (id) => http.patch(`/notifications/${id}/read`).then(data),
  // → { unread }
  markAllRead: () => http.post("/notifications/read-all").then(data),
  // ids ≤ 200 → { unread }
  markManyRead: (ids) => http.post("/notifications/read", { ids }).then(data),
};

/* ---------- Notification settings (company-setup, COMPANY scope) ---------- */
export const notificationSettingsApi = {
  // → { types: [{ type, group, label, recipient }], probationRecipients, defaults }
  catalog: () => http.get("/notification-settings/catalog").then(data),
  // → { companyId, config, source: OWN|INHERITED|GLOBAL|DEFAULT, inheritedFrom }
  get: (companyId) =>
    http
      .get("/notification-settings", { params: clean({ companyId }) })
      .then(data),
  // companyId may be "global" (super admin); body = config; → same shape as get
  save: (companyId, config) =>
    http.put(`/notification-settings/${companyId}`, config).then(data),
  // Back to the inherited setting; → same shape as get
  reset: (companyId) =>
    http.delete(`/notification-settings/${companyId}`).then(data),
};
